import React, { useState } from "react";
import { PackagesAddEdit } from "../../../../validation/UserValidation";
import Index from "../../../Index";
import PageIndex from "../../../PageIndex";

const AddEditPackeges = ({ open, setOpen, data, setData, getPackegesDetails }) => {
  const handleClose = () => {
    setOpen(false);
    setData();
  };
  const [btnLoading, setBtnLoading] = useState(false);

  const submitForm = async (value) => {
    try {
      setBtnLoading(true);
      const res = await PageIndex.DataService.post(PageIndex.API.USER.PROFESSIONAL_PACKAGE_ADDEDIT, {
        packagesId: data?._id,
        packageName: value.packageName,
        description: value.description,
      });
      if (res?.data?.status == 200 || 201) {
        PageIndex.toast.success(res?.data?.message);
        handleClose();
        getPackegesDetails();
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      handleClose();
      PageIndex.toast.error(error?.response?.data?.message);
    }
  };
  return (
    <>
      <Index.Modal
        className="prof-main-modal"
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <PageIndex.Formik
          validationSchema={PackagesAddEdit}
          initialValues={{
            packageName: data ? data.packageName : "",
            description: data ? data.description : "",
          }}
          onSubmit={submitForm}
        >
          {({
            values,
            errors,
            handleChange,
            handleBlur,
            touched,
            handleSubmit,
            setFieldValue,
          }) => (
            <form
              onSubmit={handleSubmit}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();
                }
              }}
            >
              <Index.Box className="packages-modal-main">
                <Index.Box className="prof-heading-box">
                  <Index.Typography className="prof-heading-text">
                    {data?._id ? "Edit Profile" : "Add Profile"}
                  </Index.Typography>
                </Index.Box>

                <Index.TextField
                  placeholder="Package Name"
                  size="small"
                  className="package-name-input"
                  onChange={handleChange}
                  value={values?.packageName}
                  name="packageName"
                  onBlur={handleBlur}
                  inputProps={{ maxLength: 64 }}

                />
                {errors?.packageName && touched?.packageName &&(
                  <span className="error"> {errors?.packageName} </span>
                )}

                <Index.TextField
                  placeholder="Description"
                  multiline
                  rows={3}
                  onChange={handleChange}
                  className="package-name-description"
                  value={values?.description}
                  name="description"
                  onBlur={handleBlur}
                  inputProps={{ maxLength: 200 }}
                />
                {errors?.description && touched?.description && (
                  <span className="error"> {errors?.description} </span>
                )}

                <Index.Box className="main-button-modal">
                  <Index.Box className="first-cancel-btn">
                    <Index.Button
                      onClick={() => {
                        handleClose()
                      }}
                    >
                      Cancel
                    </Index.Button>
                  </Index.Box>
                  <Index.Box className="second-delete-btn">
                    <Index.Button type="submit" disabled={btnLoading}>save</Index.Button>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </form>
          )}
        </PageIndex.Formik>
      </Index.Modal>
    </>
  );
};

export default AddEditPackeges;
